export function XIcon({ className }: { className?: string }) {
  return (
    <span className={className} aria-hidden>
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <title>X</title>
        <path d="M18.9 2H22l-6.8 7.7L23 22h-6.3l-4.9-6.4L6.2 22H3l7.2-8.3L2 2h6.4l4.4 5.9L18.9 2Zm-1.1 18h1.7L7.3 3.8H5.5L17.8 20Z" />
      </svg>
    </span>
  );
}
